export default function switchToBcService(
  $http,
  $location,
  $cookies,
  $window,
  NotificationService,
  sessionService,
  ENVIRONMENT,
  SWITCH_TO_COOKIE_KEY,
  SWITCH_TO_BC_CONFIG
) {
  function switchTo(merchant, additionalPath) {
    var sessionToken = sessionService.currentSession.token,
      defaultPath = 'reservations/list',
      location,
      cookieValue,
      cookieConfig;

    if (!merchant.id) {
      NotificationService.error('Invalid merchant ID');
      return;
    }

    location = getBcLocation(merchant.id);

    additionalPath = additionalPath ? additionalPath : defaultPath;
    location += additionalPath;

    if (!location) {
      NotificationService.error('Invalid BC location');
      return;
    }

    if (!sessionToken) {
      NotificationService.error('Invalid session token');
      return;
    }

    cookieValue = {
      token: sessionToken,
      merchantId: merchant.id,
      businessName: merchant.name,
      locale: merchant.locale,
      currency: merchant.currency,
      chainId: merchant.chainDto ? merchant.chainDto.id : '',
      productTypeIds: merchant.productIds,
    };

    cookieConfig = {
      domain: SWITCH_TO_BC_CONFIG.QUANDOO_DOMAIN,
      expires: moment()
        .add(1, 'minute')
        .toDate(),
    };

    $http.post(SWITCH_TO_BC_CONFIG.AUDIT_ENDPOINT + '/' + merchant.id, {}).then(function(res) {
      if (res.data) {
        cookieValue.token = res.data;
      }
      $cookies.putObject(SWITCH_TO_COOKIE_KEY, cookieValue, cookieConfig);
      $window.open(location, '_blank');
    });
  }

  function getBcLocation(merchantId) {
    var host = $location.host(),
      location;

    // When build with docker the bc url will be in window
    if (window.ENVIRONMENT.BC_URI) {
      return `${window.ENVIRONMENT.BC_URI}${merchantId}/`;
    }

    switch (host) {
      case ENVIRONMENT.LOCAL[0]:
        location = SWITCH_TO_BC_CONFIG.BC_LOCATION.LOCAL;
        break;
      case ENVIRONMENT.IQA[0]:
        location = SWITCH_TO_BC_CONFIG.BC_LOCATION.IQA;
        break;
      case ENVIRONMENT.IWEB[0]:
        location = SWITCH_TO_BC_CONFIG.BC_LOCATION.IWEB;
        break;
      case ENVIRONMENT.TEST[0]:
        location = SWITCH_TO_BC_CONFIG.BC_LOCATION.TEST;
        break;
      case ENVIRONMENT.BETA[0]:
        location = SWITCH_TO_BC_CONFIG.BC_LOCATION.BETA;
        break;
      case ENVIRONMENT.LIVE[0]:
        location = SWITCH_TO_BC_CONFIG.BC_LOCATION.LIVE;
        break;
      default:
        location = SWITCH_TO_BC_CONFIG.BC_LOCATION.IWEB;
    }

    return location + merchantId + '/';
  }

  return { switchTo: switchTo };
}



// WEBPACK FOOTER //
// ./src/app/common/services/switchToBc.service.js